module.exports = __webpack_public_path__ + "img/fiskeri_akvakultur_med_paavirkningsgrad.8dd0ec79.jpg";